import React, { Component } from 'react';
import { Grid, Row, Col, Button, Spinner } from 'react-bootstrap';
import Card from 'components/Card/Card.jsx';
import Form from 'react-jsonschema-form';
import axios from 'axios';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as UsersActions from './redux/UsersActions';

import DeleteButton from '../../lib/components/DeleteButton';
import widgets from '../../lib/widgets';
import fields from '../../lib/fields';
import feathers from '../../feathers';
import auth from '../../lib/auth';

let params = {
  /*   where: {
    franchiseId: auth.getCurrentUser().franchiseId
  } */
};

const schema = {
  $id: 'http://example.com/example.json',
  type: 'object',
  definitions: {},
  $schema: 'http://json-schema.org/draft-07/schema#',
  required: ['firstName', 'lastName', 'email', 'phone', 'franchiseId'],
  properties: {
    firstName: {
      $id: '/properties/firstName',
      type: 'string',
      title: 'Nombre(s)',
      default: '',
      examples: ['Ana'],
    },
    lastName: {
      $id: '/properties/lastName',
      type: 'string',
      title: 'Apellidos',
      default: '',
      examples: ['Guerrero Lara'],
    },
    email: {
      $id: '/properties/email',
      type: 'string',
      title: 'Email',
      default: '',
      examples: ['example@gmail.com'],
    },
    password: {
      $id: '/properties/password',
      type: 'string',
      title: 'Contraseña',
      default: '',
      examples: ['example'],
    },
    phone: {
      $id: '/properties/phone',
      type: 'string',
      title: 'Teléfono',
      default: '',
      examples: ['443 45 43 45'],
    },
    roles: {
      $id: '/properties/roles',
      type: 'array',
      title: 'Rol',
      api: process.env.REACT_APP_URL_API + '/api/roles',
      options: {
        value: 'id',
        label: 'name',
      },
      default: '',
      items: {
        $id: '/properties/roles/items',
        type: 'string',
        title: 'The 0th Schema ',
        default: '',
      },
      examples: [''],
    },

    franchiseId: {
      $id: '/properties/franchiseId',
      type: 'string',
      title: 'Franquicia',
      api:
        process.env.REACT_APP_URL_API +
        '/api/franchises?filter=' +
        JSON.stringify(params),
      options: {
        value: 'id',
        label: 'name',
      },
      default: '',
      examples: [''],
    },
    emailConfiguration: {
      $id: '/properties/email',
      type: 'object',
      title: 'Configuración del correo',
      properties: {
        email: {
          $id: '/properties/email',
          type: 'string',
          title: 'Email para enviar correos',
          default: '',
          examples: ['example@gmail.com'],
        },
        password: {
          $id: '/properties/password',
          type: 'string',
          title: 'Contraseña del email para enviar correos',
          default: '',
          examples: ['example'],
        },
      },
    },
  },
};

const uiSchema = {
  roles: {
    'ui:field': 'SelectMultipleRemoteWidget',
  },
  franchiseId: {
    'ui:widget': 'SelectRemoteWidget',
  },
  email: {
    'ui:widget': 'email',
  },
  password: {
    'ui:widget': 'password',
  },
  emailConfiguration: {
    password: {
      'ui:widget': 'password',
    },
  },
};

const log = (type) => console.log.bind(console, type);

class UsersForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      formData: {
        roles: [],
      },
      originalFormData: {},

      deleteSuccess: false,
      sendEmailText: 'ENVIAR EMAIL DE PRUEBA',
      sendingEmail: false,
      sendingButton: 'primary',
      emailTest: '',
      isLoading: false,
    };
  }

  componentWillMount() {
    if (this.state.id !== 'create') {
      var param = {
        include: ['roles'],
      };
      this.props.findById(this.state.id, param);
    }
    console.log('Fid: ', auth.getCurrentUser().franchiseId);
  }

  componentWillReceiveProps(nextProps) {
    var newFormData = {
      ...nextProps.Users.formData,
    };

    var newOriginalFormData = JSON.parse(JSON.stringify(newFormData));

    this.setState({
      formData: newFormData,
      originalFormData: newOriginalFormData,
    });
  }

  addRelation(formData, relation) {
    //Multiple Select Relation
    console.log(formData[relation], this.state.originalFormData);
  }

  onSubmit = async ({ formData }) => {
    let _this = this;
    if (
      formData.password === '' ||
      formData.password === undefined ||
      formData.password === null
    )
      delete formData.password;

    this.setState({ isLoading: true });
    if (this.state.id !== 'create') {
      await feathers.service('users').patch(formData.id, formData);
      this.setState({ isLoading: false });
      _this.props.history.push('/admin/users');
    } else {
      await feathers.service('users').create(formData);
      this.setState({ isLoading: false });
      _this.props.history.push('/admin/users');
    }
  };

  onDelete = () => {
    let _this = this;
    this.props.remove(this.state.id).then(() => {
      this.setState({
        deleteSuccess: true,
      });
      setTimeout(() => {
        _this.props.history.push('/admin/users');
      }, 2000);
    });
  };

  onBlur = (id, value) => {
    if (id === 'root_emailConfiguration_password') {
      this.setState({
        formData: {
          ...this.state.formData,
          emailConfiguration: {
            ...this.state.formData.emailConfiguration,
            password: value,
          },
        },
      });
    }

    if (id === 'root_emailConfiguration_email') {
      this.setState({
        formData: {
          ...this.state.formData,
          emailConfiguration: {
            ...this.state.formData.emailConfiguration,
            email: value,
          },
        },
      });
    }
  };

  sendEmail = async () => {
    if (this.state.sendingEmail === false) {
      this.setState({
        sendEmailText: 'ENVIANDO ...',
        sendingEmail: true,
        sendingButton: 'default',
      });

      var sendedEmail = await axios.post(
        process.env.REACT_APP_URL_API + '/email-quotation',
        {
          test: true,
          email: this.state.formData.emailConfiguration.email,
          password: this.state.formData.emailConfiguration.password,
          emailTest: this.state.emailTest,
        }
      );

      if (sendedEmail.data.sended === true) {
        this.setState({
          sendEmailText: '¡ENVIADO CORRECTAMENTE!',
          sendingButton: 'success',
        });

        setTimeout(() => {
          this.setState({
            sendEmailText: 'ENVIAR EMAIL',
            sendingEmail: false,
            sendingButton: 'primary',
          });
        }, 2000);
      } else {
        this.setState({
          sendEmailText: sendedEmail.data.message,
          sendingButton: 'danger',
        });

        setTimeout(() => {
          this.setState({
            sendEmailText: 'ENVIAR EMAIL',
            sendingEmail: false,
            sendingButton: 'primary',
          });
        }, 5000);
      }

      console.log('Email Enviado', sendedEmail);
    }
  };

  onChangeEmailTest = (event) => {
    this.setState({
      emailTest: event.target.value,
    });
  };

  render() {
    const { history } = this.props;
    const { formData, isLoading } = this.state;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={<legend>Editar Usuario</legend>}
                content={
                  <div>
                    <Form
                      schema={schema}
                      fields={fields}
                      widgets={widgets}
                      uiSchema={uiSchema}
                      onSubmit={this.onSubmit}
                      onBlur={this.onBlur}
                      formData={formData}
                      onError={log('errors')}
                    >
                      <div>
                        <Button
                          bsStyle="success"
                          type="submit"
                          className="btn-fill"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <span>
                              Guardando... <i className="fa fa-spinner fa-spin" />
                            </span>
                          ) : (
                            'Guardar'
                          )}
                        </Button>{' '}
                        <Button
                          bsStyle="default"
                          onClick={() => history.push('/admin/users')}
                        >
                          Cancelar
                        </Button>
                        <div className="pull-right">
                          {auth.can('support') ? (
                            <DeleteButton
                              onConfirm={this.onDelete}
                              success={this.state.deleteSuccess}
                            />
                          ) : null}
                        </div>
                      </div>
                    </Form>
                    <br />

                    <Row>
                      <Col md="2">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Correo de prueba"
                          onChange={this.onChangeEmailTest}
                        />
                        <Button
                          bsStyle={this.state.sendingButton}
                          wd
                          onClick={this.sendEmail}
                        >
                          {this.state.sendEmailText}
                        </Button>
                      </Col>
                    </Row>

                    <div className="clearfix" />
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Users: state.Users,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(UsersActions, dispatch);
};

const UsersConnect = connect(mapStateToProps, mapDispatchToProps)(UsersForm);

export default UsersConnect;



// WEBPACK FOOTER //
// ./src/views/Users/UsersForm.jsx